import { fetchFromOldApi } from '~/services/Http';

export const getManagerIds = async (): Promise<number[]> => {
  return await fetchFromOldApi(`/json/user/role/MANAGER`).then((r) => r.json());
};

export const getTeamManagerIds = async (): Promise<number[]> => {
  return await fetchFromOldApi(`/json/user/role/DEPUTY_MANAGER`).then((r) =>
    r.json(),
  );
};

export const getAlternateManagerIds = async (): Promise<number[]> => {
  return await fetchFromOldApi(`/json/user/role/ALT_MANAGER`).then((r) =>
    r.json(),
  );
};
